<template>
  <div>
    <p>
      <span class="txt">类型</span>
      <el-select v-model="types" clearable size="small" placeholder="请选择类型">
        <el-option :value="0" label="会议室"/>
        <el-option :value="1" label="主持人"/>
        <el-option :value="2" label="会议秘书"/>
        <el-option :value="3" label="参会人"/>
        <el-option :value="4" label="召集人"/>
      </el-select>
      <span class="txt">评分维度</span>
      <el-input
        v-model="scoreName"
        size="small"
        clearable
        placeholder="请输入内容"
        style="width:180px;margin-right:20px;"
      />
      <el-button size="mini" type="primary" icon="el-icon-search" @click="searchBtn">查询</el-button>
      <el-button size="mini" type="success" icon="el-icon-plus" @click="dialogFormVisible = true">新增</el-button>
    </p>
    <el-table
      :data="tableData"
      :header-cell-style="{background:'#41A1FF',color:'#fff'}"
      border
      size="small"
      style="width: 100%"
    >
      <el-table-column align="center" prop="type" label="类型">
        <template slot-scope="scope">
          <span v-show="scope.row.type === 0">会议室</span>
          <span v-show="scope.row.type === 1">主持人</span>
          <span v-show="scope.row.type === 2">会议秘书</span>
          <span v-show="scope.row.type === 3">参会人</span>
          <span v-show="scope.row.type === 4">召集人</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="name" label="评分维度" />
      <el-table-column align="center" prop="creator_name" label="创建人" />
      <el-table-column align="center" fixed="right" label="操作" width="300">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="editBtn(scope.row)">编辑</el-button>
          <!-- <el-button type="danger" size="small" @click="deleteBtn(scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px;text-align: center;">
      <el-pagination
        :page-sizes="[5, 10, 30, 50]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog :visible.sync="dialogFormVisible" title="新增维度">
      <el-form ref="addForm" :model="addForm" :rules="rules">
        <el-form-item :label-width="formLabelWidth" label="类型" prop="type">
          <el-select v-model="addForm.type" clearable style="width:100%;" placeholder="请选择类型">
            <el-option :value="0" label="会议室"/>
            <el-option :value="1" label="主持人"/>
            <el-option :value="2" label="会议秘书"/>
            <el-option :value="3" label="参会人"/>
            <el-option :value="4" label="召集人"/>
          </el-select>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="评分维度" prop="name">
          <el-input v-model="addForm.name" clearable type="text" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="canceladdForm">取消</el-button>
        <el-button size="small" type="primary" @click="submitAdd('addForm')">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog  :visible.sync="editFormVisible" :close-on-click-modal="false" title="编辑维度">
      <el-form ref="editForm" :model="editForm" :rules="rules">
        <el-form-item :label-width="formLabelWidth" label="类型" prop="type">
          <el-select v-model="editForm.type" clearable style="width:100%;" placeholder="请选择类型">
            <el-option :value="0" label="会议室"/>
            <el-option :value="1" label="主持人"/>
            <el-option :value="2" label="会议秘书"/>
            <el-option :value="3" label="参会人"/>
            <el-option :value="4" label="召集人"/>

          </el-select>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="评分维度" prop="name">
          <el-input type="textarea" v-model="editForm.name" clearable  placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="canceleditForm">取 消</el-button>
        <el-button size="small" type="primary" @click="submitEdit">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { getUserInfoByIdList } from '@/api/login'
import {
  searchScoringDimension,
  addScoringDimension,
  editScoringDimension,
  deleteScoringDimension
} from '@/api/common'
// import { regionData  } from 'element-china-area-data';//省市
export default {
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 10,
      scoreName: '',
      types: '',
      tableData: [],
      dialogFormVisible: false,
      editFormVisible: false,
      addForm: {
        name: '',
        type: ''
      },
      editForm: {
        id: '',
        name: '',
        type: ''
      },
      formLabelWidth: '120px',
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        type: [{ required: true, message: '请选择', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.searchBtn()
  },
  methods: {
    getList() {
      var responseData = [
        {
          tb_creater: 1692,
          date: '2016-05-07',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          tb_creater: 1670,
          date: '2016-05-07',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }
      ]
      if (responseData) {
        const tb_creater_list = []

        for (const i in responseData) {
          tb_creater_list.push(responseData[i].tb_creater)
        }
      }
      this.tableData = responseData
    },
    // 搜索列表
    searchBtn() {
      const params = {
        name: this.scoreName,
        type: this.types,
        page: this.pageNum,
        page_size: this.pageSize
      }
      searchScoringDimension(params)
        .then(response => {
          console.log(response)

          const data = response.data.settings
          if (data.length) {
            this.tableData = data
          } else {
            this.tableData = []
          }
          this.pageSize = response.data.pagination.page_size
          this.pageNum = response.data.pagination.current_page
          this.total = response.data.pagination.total
        })
        .catch(() => {})
    },
    canceleditForm() {
      this.editFormVisible = false
      this.editForm.name = ''
      this.editForm.type = ''
    },
    canceladdForm() {
      this.dialogFormVisible = false
      this.addForm.name = ''
      this.addForm.type = ''
    },
    // 提交新增
    submitAdd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          addScoringDimension(this.addForm)
            .then(response => {
              if (response.code === 'success') {
                this.successMsg()
                this.dialogFormVisible = false
                this.addForm.name = ''
                this.addForm.type = ''
                this.searchBtn()
              } else {
                this.errMsg()
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 编辑点击
    editBtn(row) {
      console.log(row)
      this.editForm.id = row.id
      this.editForm.name = row.name
      this.editForm.type = row.type
      this.editFormVisible = true
    },
    // 提交修改
    submitEdit() {
      editScoringDimension(this.editForm)
        .then(response3 => {
          if (response3.code === 'success') {
            this.successMsg()
            this.editFormVisible = false
            this.editForm.name = ''
            this.editForm.type = ''
            this.searchBtn()
          } else {
            this.errMsg()
          }
        })
        .catch()
    },
    // 提交修改
    deleteBtn(row) {
      console.log(row)

      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteScoringDimension(row.id)
            .then(response => {
              console.log(response)

              if (response.code === 'success') {
                this.successMsg()
                this.editFormVisible = false
                this.searchBtn()
              } else {
                this.errMsg()
              }
            })
            .catch(error => {
              console.log(error)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    successMsg() {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
    },
    errMsg() {
      this.$message({
        message: '操作失败',
        type: 'error'
      })
    },
    handleSizeChange(val) {
      this.pageSize = val

      const data = {
        page: this.pageNum,
        page_size: this.pageSize
      }
      this.searchBtn(data)
    },
    handleCurrentChange(val) {
      this.pageNum = val
      const data = {
        page: this.pageNum,
        page_size: this.pageSize
      }
      this.searchBtn(data)
    }
  }
}
</script>
<style scope>
.txt {
  text-align: right;
  vertical-align: middle;
  font-weight: 700;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
